import styled from 'styled-components';
import { SIZE } from '../../common/sizes';
import { DEFAULT_FONT_FAMILY } from 'common/constants';
import { InputWrapper } from '../TCInputField/styles';
import { Label } from 'common/baseComponents';


export interface SearchDecoratorWrapperProps {
    isReverse?: boolean
}
export const SearchDecoratorWrapper = styled.div`
    display:flex;
    flex-direction: ${(props: SearchDecoratorWrapperProps) => props.isReverse ? "row-reverse" : "row"};
    justify-content: flex-end;
    align-items: center;
`

export const SearchInput = styled.input`

    outline: none;
    display: flex;
    padding: none;
    border: none;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 1.5px;
    font-size: 14px;
    :read-only { 
        color: cyan;
        cursor: not-allowed 
    };


    flex: 1;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 16px;
    height: 30px;
    color: #373f53;
    margin-left: ${(props: SearchDecoratorWrapperProps) => props.isReverse ? null : `${SIZE.HALF}px`};
    ::placeholder {
        font-family: Jaldi;
        font-size: 16px;
        color: #7283ad;
    };
    background: rgba(0,0,0,0);

`

export const SearchIcon = styled.span`
    justify-content: center;
    align-items: center;
    font-family: 'icomoon' !important;
    border-radius: 50%;
    background-color: #ffffff;
    color: #7283ad;
    font-size: 18px;
    padding: 5px 5px 5px 5px;
    width: ${SIZE.THREE}px;
`

export const SearchFieldContainer = styled.div`
    display: flex;
    flex:1;
    overflow: hidden;
    text-overflow: ellipsis;
`

export const SearchFieldHighlighted = styled(Label)`
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 14px;
    color: #373f53;
    font-weight: 600;
`

export const SearchFieldNormal = styled(Label)`
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 14px;
    color: #373f53;
    display: flex;
    flex:1;
`

export const SearchBoxContainer = styled.div`
    display: flex;
    ${InputWrapper}  {
        height: ${SIZE.FOUR}px;
    };
`

export const SearchFieldContentBag = styled.div`
    display: flex;
`